// extracted by mini-css-extract-plugin
module.exports = {"container":"Section-module--container--1TV5_","titleContainer":"Section-module--titleContainer--2uDuJ","title":"Section-module--title--3xgiF"};